// assets
import {
  IconHome,
  IconUser,
  IconSettings,
  IconBuildingCommunity,
  IconChartLine,
  IconChartBar,
  IconLicense,
  IconMessages,
  IconNews,
  IconListCheck,
  IconBrandInstagram,
  IconMessageCircle,
  IconLogout,
  IconTractor,
  IconWindmill,
  IconBoxPadding,
  IconCalendar,
  IconFileText,
  IconFolder,
  IconFileReport
} from '@tabler/icons';

// constant
const icons = {
  IconHome,
  IconUser,
  IconSettings,
  IconChartLine,
  IconChartBar,
  IconLicense,
  IconBuildingCommunity,
  IconMessages,
  IconNews,
  IconListCheck,
  IconBrandInstagram,
  IconMessageCircle,
  IconLogout,
  IconTractor,
  IconWindmill,
  IconBoxPadding,
  IconCalendar,
  IconFileText,
  IconFolder,
  IconFileReport
};

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const adm = {
  id: 'adm',
  type: 'group',
  titleName: true,
  children: [
    {
      id: 'index',
      title: 'Home',
      type: 'item',
      url: '/index',
      icon: icons.IconHome,
      breadcrumbs: false,
      color: 'success',
      variant: 'success',
    },
    {
      id: 'corretivas',
      title: 'OS Corretivas',
      type: 'item',
      url: '/corretivas',
      icon: icons.IconListCheck,
      breadcrumbs: false,
      color: 'success',
      variant: 'success',
    },
    {
      id: 'proativas',
      title: 'OS Proativas',
      type: 'item',
      url: '/proativas',
      icon: icons.IconListCheck,
      breadcrumbs: false,
      color: 'success',
      variant: 'success',
    },
    {
      id: 'chamados_gerente',
      title: 'OS Gerente',
      type: 'item',
      url: '/chamados_gerente',
      icon: icons.IconListCheck,
      breadcrumbs: false,
      color: 'success',
      variant: 'success',
    },
    {
      id: 'preventivas',
      title: 'OS Preventivas',
      type: 'item',
      url: '/preventivas',
      icon: icons.IconListCheck,
      breadcrumbs: false,
      color: 'success',
      variant: 'success',
    },
    {
      id: 'uras',
      title: 'URA',
      type: 'item',
      url: '/uras',
      icon: icons.IconListCheck,
      breadcrumbs: false,
      color: 'success',
      variant: 'success',
    },
    {
      id: 'report_task',
      title: 'Relatório',
      type: 'item',
      url: '/report_task',
      icon: icons.IconFileReport,
      breadcrumbs: false,
      color: 'success',
      variant: 'success',
    },,
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: icons.IconChartLine,
      breadcrumbs: false,
      color: 'success',
      variant: 'success',
    },
    {
      id: 'cronograma_anual',
      title: 'Cronograma',
      type: 'item',
      url: '/cronograma_anual',
      icon: icons.IconCalendar,
      breadcrumbs: false,
      color: 'success',
      variant: 'success',
    },
    {
      id: 'pendencias',
      title: 'Pendências',
      type: 'item',
      url: '/pendencias',
      icon: icons.IconFileText,
      breadcrumbs: false,
      color: 'success',
      variant: 'success',
    },
    {
      id: 'diretorio',
      title: 'Diretório',
      type: 'item',
      url: '/diretorio',
      icon: icons.IconFolder,
      breadcrumbs: false,
      color: 'success',
      variant: 'success',
    }
    
  ],
};

export default adm;
